import { reduce, sortBy, round, keys, values, merge } from 'lodash';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

function quantile(array, percentile) {
    const index = (percentile / 100.0) * (array.length - 1);
    if (Math.floor(index) === index) {
        return array[index];
    }
    const i = Math.floor(index);
    const fraction = index - i;
    return array[i] + (array[i + 1] - array[i]) * fraction;
}

export async function getBoxPlotConfig(dataService, filterState, search, callback) {
    const { data } = await dataService.get('/query/testLog', {
        ...merge({}, ...values(filterState?.parameters)),
        ...(search ? { search } : {}),
        type: 'test',
        test: 'UIPerformance',
        metrics: 'avgloadtime,pagename',
        trends: 'avgloadtime',
        searchFields: 'pagename',
        rowLimit: 100000,
    });

    const mappedData = reduce(
        data,
        (namesMap, { avgloadtime, pagename }) => {
            // eslint-disable-next-line no-param-reassign
            if (!namesMap[pagename]) namesMap[pagename] = [];
            namesMap[pagename].push(round(avgloadtime));
            return namesMap;
        },
        {}
    );

    const uniquePages = keys(mappedData);
    const seriesData = uniquePages.map((page, index) => {
        const pageResponses = sortBy(mappedData[page]);
        return {
            x: index,
            low: pageResponses[0],
            high: pageResponses[pageResponses.length - 1],
            q1: quantile(pageResponses, 25),
            median: quantile(pageResponses, 50),
            q3: quantile(pageResponses, 75),
        };
    });

    callback({
        title: {
            text: '',
        },
        chart: {
            type: 'boxplot',
            inverted: true,
        },
        legend: { enabled: false },
        credits: { enabled: false },
        xAxis: {
            categories: uniquePages,
        },
        yAxis: { title: { text: i18n._(t`Load Time (ms)`) } },
        tooltip: {
            valueSuffix: 'ms',
        },
        series: [{ name: i18n._(t`Load Time`), data: seriesData }],
    });
}
